import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import OrderRow from "./OrderRow";

const OrdersTable = ({ orders, onMenuOpen, currentPage, limit }) => {
  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#1976d2" }}>
            {["Sr. No", "ID", "Name", "Email", "Contact", "Payment Gateway", "Amount", "Currency", "Status", "Created At", "Actions"].map((header) => (
              <TableCell key={header} sx={{ color: "white" }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((order, index) => (
            <OrderRow
              key={order.id}
              order={order}
              srNo={(currentPage - 1) * limit + (index + 1)} // Serial number formula
              onMenuOpen={onMenuOpen}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrdersTable;
